module.exports = __webpack_public_path__ + "img/skull_5.ba77b238.png";